import { Injectable, Signal, signal } from '@angular/core';
import { Platform } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { UpdateAppService } from './update-app.service';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
  private servicioActivo = signal<boolean>(true);
  private intervalId: any;

  constructor(private updateAppSrv: UpdateAppService) {}

  checkForUpdates(platform: Platform): void {
    const check = () => {
      this.updateAppSrv.checkForUpdate().subscribe({
        next: (update) => {
          const version = platform.is('ios') ? update.versions.ios : update.versions.android;
          if (version && environment.version !== version) {
            // emitir alerta (esto se haría desde AppComponent usando un efecto reactivo o subscribe al signal)
          }
          this.servicioActivo.set(true);
          this.clear();
        },
        error: () => {
          this.servicioActivo.set(false);
        },
      });
    };

    check();
    this.intervalId = setInterval(() => {
      if (!this.servicioActivo()) {
        check();
      }
    }, 2000);
  }

  get isServicioActivo(): Signal<boolean> {
    return this.servicioActivo;
  }

  clear(): void {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}